import React from 'react'
import {Button} from "reactstrap";

const DeleteIncompleteStudent =({deleteIncompleteStu,setIncompleteDeleteModal})=> {
    
    const deleteRecord= ()=>{
        setIncompleteDeleteModal(false)
        deleteIncompleteStu()

    }

    const onclick= ()=>{
        setIncompleteDeleteModal(false)
    }
    return (
    <div>
        <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
        <p >Do you want to delete Selected Students Account ?</p>
        </div>
        <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>
        <Button color='info' onClick={deleteRecord}>Yes</Button>
        <Button  onClick={onclick}>No</Button>
        </div>
    </div>
    )
}

export default DeleteIncompleteStudent;
